export const OrderConstants = {
    MAX_PO_NUMBER_LENGTH: 255,
} as const;
